import { useMutationState } from '@tanstack/react-query';
import { useMemo } from 'react';
export const DELETE_COLLECTION_MUTATION_KEY = ['deleteCollection'];
// These signals live only as long as this QueryClient retains its mutation history.
// Consumers that retain rows must apply deletions to their own state while the signal exists.
export function useSuccessfulDeletedCollectionUuids() {
    const successfulDeleteVariables = useMutationState({
        filters: {
            exact: true,
            mutationKey: DELETE_COLLECTION_MUTATION_KEY,
            status: 'success',
        },
        select: (mutation) => mutation.state.variables,
    });
    return useMemo(() => successfulDeleteVariables.filter((uuid) => typeof uuid === 'string'), [successfulDeleteVariables]);
}
//# sourceMappingURL=deleteCollectionMutationState.js.map